import React, { useState, useEffect } from "react";
import TableManage from "./Components/TableManage";
import { dataService } from "../../../Services/data/data.service";
import { fromNewDateFormatToYYYYMMDDSlash } from "../../../Utils/dateHelper";
import { Grid2, Divider, Box } from "@mui/material";
import DateSelectionFuture from "../../Shared/DateSelection/DateSelectionFuture";
import { makeStyles } from "@material-ui/core/styles";
import { ProjectFilterTypes } from '../../../Config/constants';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Spin } from "react-cssfx-loading";
import { toast } from 'react-toastify';


function ManagePage(props) {
    var today = new Date();
    var nextMonth = new Date();
    nextMonth.setDate(nextMonth.getDate() + 30);
    const navigate = useNavigate();
    const [firstLoad, setFirstLoad] = useState(0);
    const [FromDate, setFromDate] = useState(today);
    const [ToDate, setToDate] = useState(nextMonth);
    const GetUserId = props.Login.userid;
    const classes = useStyles();
    const [types, setTypes] = useState([]);
    const [filters, setFilters] = useState([]);
    const [filterOn, setFilterOn] = useState(false);
    const [measurementRows, setMeasurementRows] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState(8);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dataService.getTypes().then(results => {
            if (results) {
                setTypes(results.sort((a, b) => a.description.localeCompare(b.description)));
            }
        });
    }, [])

    const setTheFromDate = (event) => {
        if (event !== FromDate) {
            setFromDate(event);
            setDates(event, ToDate);
        }
    }
    const setTheToDate = (event) => {
        if (event !== ToDate) {
            setToDate(event);
            setDates(FromDate, event);
        }
    }

    const setDates = (fromDate, toDate) => {
        setToDate(toDate);
        setFromDate(fromDate);
        sendApi(fromDate, toDate);
    }


    const sendApi = (fromDate, toDate) => {
        // eslint-disable-next-line
        let sort;
        dataService.getMeasurementForModify(GetUserId, fromNewDateFormatToYYYYMMDDSlash(new Date(fromDate)), fromNewDateFormatToYYYYMMDDSlash(new Date(toDate))).then(results => {
            sort = results.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.fromDate) - new Date(a.fromDate);
            });
        }).catch((error) => {
            toast.error('Something went wrong while fetching the data.', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            console.log('Error: ', error)
        }).finally(() => {
            setMeasurementRows(sort)
            setProjects(sort);
            setLoading(false);
        })
    }

    if (firstLoad === 0) {
        sendApi(FromDate, ToDate);
        setFirstLoad(1);
    }

    const filter = [
        { number: 1, column: "companyName", sortOrder: "ASC" },
        { number: 2, column: "companyName", sortOrder: "DESC" },
        { number: 3, column: "projectName", sortOrder: "ASC" },
        { number: 4, column: "projectName", sortOrder: "DESC" },
        { number: 5, column: "resourceName", sortOrder: "ASC" },
        { number: 6, column: "resourceName", sortOrder: "DESC" },
        { number: 7, column: "fromDate", sortOrder: "ASC" },
        { number: 8, column: "fromDate", sortOrder: "DESC" },
    ]

    const dynamicSorting = (property) => {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        let asc = false;

        /* SC: Filter now works both ways (ASC, DESC) */
        if (filter.find(x => x.number === selectedFilter).column === property) {
            if (filter.find(x => x.number === selectedFilter).sortOrder === 'ASC') {
                asc = false;
                setSelectedFilter(filter.find(x => x.column === property && x.sortOrder === 'DESC').number);
            } else {
                asc = true;
                setSelectedFilter(filter.find(x => x.column === property && x.sortOrder === 'ASC').number);
            }
        } else {
            asc = true;
            setSelectedFilter(filter.find(x => x.column === property && x.sortOrder === 'ASC').number);
        }
        if (asc === true) {
            return function (a, b) {
                var result = (a[property].toLowerCase() > b[property].toLowerCase() ? 1 : -1);
                return result * sortOrder;
            }
        } else {
            return function (a, b) {
                var result = (a[property].toLowerCase() < b[property].toLowerCase() ? 1 : -1);
                return result * sortOrder;
            }
        }
    }

    const handleSorting = (sortType) => {
        let tempMeasurementRows = [...projects];
        setProjects(tempMeasurementRows.sort(dynamicSorting(sortType)));
    }


    const toggleFilter = () => {
        if (filterOn) {
            setFilters([]);
        }
        setFilterOn(!filterOn);
    }

    const updateFilters = (type, event) => {
        let tempFilters = [...filters];
        if (tempFilters.some(x => x.type === type)) {
            let index = tempFilters.indexOf(tempFilters.find(x => x.type === type));
            tempFilters.splice(index, 1);
            tempFilters.unshift({ type: type, filterValue: event.target.value });
        }
        else {
            tempFilters.unshift({ type: type, filterValue: event.target.value });
        }

        setFilters(tempFilters);
        filterProjects(tempFilters);
    }

    const filterProjects = (thisFilters) => {
        let varFilteredProjects = [...measurementRows];
        var i;
        for (i = 0; i < thisFilters.length; i++) {
            let filter = thisFilters[i]
            switch (filter.type) {
                case ProjectFilterTypes.CUSTOMER:
                    varFilteredProjects = varFilteredProjects.filter(x => x.companyName.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
                case ProjectFilterTypes.PROJECT_NAME:
                    varFilteredProjects = varFilteredProjects.filter(x => x.projectName.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
                case ProjectFilterTypes.LOCATION_NAME:
                    varFilteredProjects = varFilteredProjects.filter(x => x.resourceName.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
                default:
                    varFilteredProjects = varFilteredProjects.filter(x => x.companyName.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
            }
        }
        setProjects(varFilteredProjects)
    }

    const navigateTo = (destination) => {
        navigate(destination);
    }

    return (
        <React.Fragment>
            {loading &&
                <div className={classes.loadingChart}><Spin width="100px" height="100px" color="var(--color-primary)"></Spin></div>
            }
            <Box className="page-container">
                <div className={classes.header}>
                    <h1>Manage projects</h1>
                    <button className={classes.primaryIconButton} onClick={() => navigateTo('/create', { state: { from: '/manage' } })} >
                        <Plus className={classes.iconButton__icon} />
                        Create a project
                    </button>
                </div>
                <Box className={classes.container}>
                    <Grid2
                        container
                        columnSpacing={3}
                        rowSpacing={1}
                        alignItems="center">
                        <Grid2 item size={12} >
                            <div className={classes.dateAndCreateDiv}>
                                <div className={classes.dateSelectionDiv}>
                                    <p className={classes.activeFor}>Active between: </p>
                                    <DateSelectionFuture setDates={setDates} FromDate={FromDate} ToDate={ToDate} setTheFromDate={setTheFromDate} setTheToDate={setTheToDate} />
                                </div>

                            </div>
                            <Divider style={{ marginTop: "1rem", marginBottom: "1rem" }}></Divider>
                        </Grid2>
                        <Grid2 item size={12}>
                            <TableManage toggleFilter={toggleFilter} filters={filters} handleSorting={handleSorting} filterOn={filterOn} filterProjects={filterProjects} updateFilters={updateFilters} types={types} rows={projects} />
                        </Grid2>
                    </Grid2>
                </Box>

            </Box>
        </React.Fragment>
    )
}

export default ManagePage;

const useStyles = makeStyles({
    loadingChart: {
        height: '100vh',
        width: '100%',
        top: '0px',
        position: 'fixed',
        zIndex: '999',
        borderRadius: "8px",
        backgroundColor: 'rgba(156,156,156,0.5)',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        background: "#FFFFFF",
        borderRadius: "8px",
        padding: "1.5rem",
        maxWidth: "100%",
    },

    header: {
        width: "100%",
        height: "40px",

        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        marginBottom: "16px",
    },

    primaryIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "var(--color-primary)",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },

    dateAndCreateDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'end',
        flexWrap: 'wrap',


    },

    activeFor: {
        color: "#696969",
        fontSize: "15px",
    },

    linkButton: {
        color: 'white !important',
        background: "var(--color-primary) !important",
        border: "1px solid var(--color-primary) !important",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: '0.3s',
        "&:hover": {
            background: "rgba(195, 153, 107, 0.85) !important",

        },
    },
});